import { createMuiTheme } from '@material-ui/core/styles';

const customPalette = {
  container: {
    background: '#FFFFFF',
    shadow: '#CCCCCC',
    border: '#D5D5D5',
    dark: '#888888',
  },
  icon: {
    disabled: '#b5b5b5',
  },
  modal: {
    overlay: '#CCCCCC70',
  },
  table: {
    head: {
      contrast: '#DBCDC4',
    },
    row: {
      hover: '#EEEEEE',
      text: '#707070',
    },
  },
  map: {
    airport: '#004cff',
    coverage: '#16D067',
    hyspexCoverage: '#004d20',
    flightPath: '#FFC800',
    jurisdiction: ['#004BFF', '#05D894', '#00B4FF'],
    pipelineCenterline: '#D11111',
    rightOfWay: '#D62922',
    route: '#232323',
    urbanArea: '#FF00D9',
    workzone: '#010101',
  },
  findingType: {
    immediate: '#FF001F',
    investigation: '#FFA400',
    noteAutomatic: '#425C5A',
    noteManual: '#77D700',
    dismissed: '#425C5A',
    unclassified: '#b5b5b5',
  },
};

const theme = createMuiTheme({
  palette: {
    primary: {
      main: '#232323',
      light: '#3C3C3C',
      xtraLight: '#4c4c4c',
    },
    secondary: {
      main: '#D56026',
      dark: '#092D28',
      light: '#FF5AA5',
    },
    background: {
      default: '#EEEEEE',
    },
    text: {
      primary: '#232323',
      light: '#707070',
      alternate: '#444444',
      onDark: '#ffffff',
    },
    success: {
      main: '#77D700',
    },
    error: {
      main: '#FF001F',
    },
    warning: {
      main: '#FFA400',
    },
    ...customPalette,
  },
});

theme.overrides = {
  MuiButton: {
    containedPrimary: {
      backgroundColor: theme.palette.secondary.main,
      '&:hover': {
        backgroundColor: theme.palette.secondary.dark,
      },
      '&.Mui-disabled': {
        backgroundImage: `linear-gradient(to right, #B6B6B6, #B6B6B6)`,
        color: 'white',
      },
    },
    outlinedPrimary: {
      position: 'relative',
      border: '1px solid transparent',
      backgroundClip: 'padding-box',
      // Since it is not really transparent, this background color might need to be overridden
      backgroundColor: theme.palette.background.default,
      borderRadius: 5,
      // It is not possible to have both a border gradient and a border radius on a button
      // An element with the gradient is hidden behind the button which gives the illusion of a border
      '&:after': {
        position: 'absolute',
        top: -1,
        left: -1,
        right: -1,
        bottom: -1,
        backgroundColor: theme.palette.secondary.main,
        content: '""',
        zIndex: -1,
        borderRadius: 5,
      },
      '&:hover': {
        border: '1px solid transparent',
        color: theme.palette.common.white,
      },
    },
  },
  MuiInput: {
    input: {
      color: theme.palette.text.primary,
    },
  },
};

export default theme;
